import React from 'react';
import { Heading } from '../../components';
import { richText } from '../../util/richText';
import { languagesHelper as language } from '../../util/languages';
import { useIntl } from '../../util/reactIntl';

import css from './ProfilePage.module.css';

const MIN_LENGTH_FOR_LONG_WORDS = 20;

const SectionTextMaybe = props => {
  const { text, heading, showAsIngress = false, name, locale, userTranslation, id } = props;
  const textClass = showAsIngress ? css.ingress : css.text;
  const content = richText(text, {
    linkify: true,
    longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS,
    longWordClass: css.longWord,
    breakChars: '/',
  });

  const intl = useIntl();

  return text ? (
    <div className={css.sectionText}>
      {heading ? (
        <Heading as="h2" rootClassName={css.sectionHeading}>
          {language.labelsTranslator(id, intl)}
        </Heading>
      ) : null}
      <p className={textClass}>{userTranslation?.[`${name}_locale_${locale}`] || content}</p>
    </div>
  ) : null;
};

export default SectionTextMaybe;
